import React from "react";
import underConstAnimation from "../assets/lotties/underContruction.json";
import { Link } from "react-router-dom";

import { Button } from "antd";
import Lottie from "react-lottie";


const underConstructionJson = {
  loop: true,
  autoplay: true,
  animationData: underConstAnimation,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

function Page404() {
  return (
    <div className="flex flex-col justify-center items-center min-h-[85vh]">
      <Lottie
        // className="w-[80%] h-[350px]"
        height={380}
        width={380}
        options={underConstructionJson}
      />
      <p className="text-center">
        <p className="text-xl text-[#1d2636] font-semibold">
          Uh oh, we can't seem to find the page you're looking for.
        </p>
        <p className="text-[#626874] text-[0.95rem]">
          Try going Home page or Contact us for more information.
        </p>
      </p>
      <Link to="/">
        <button
          className="btn-orange mt-4 px-5 text-[.92rem] py-2 mx-auto"
          type="primary"
          // shape="circle"
          // onClick={() => (window.location.href = "/")}
        >
          Go Home
        </button>
      </Link>
    </div>
  );
}

export default Page404;
